// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Featured Products ===
  const featuredSection = document.querySelector('.s-featured-products');

  if (featuredSection) {
    const title = featuredSection.querySelector(".s-featured-products__title");
    const cards = featuredSection.querySelectorAll('.s-featured-products__item');
    const pawPrint = featuredSection.querySelector('.paw-print-decor');

    // Section fade-out as you scroll past
    gsap.fromTo(
      featuredSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featuredSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featuredSection,
            start: "top 100%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Product cards animation
    if (cards.length) {
      cards.forEach((card) => {
        gsap.fromTo(
          card,
          { y: 60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: card,
              start: "top 80%",
              end: "top 60%",
              scrub: true
            }
          }
        );
      });
    }
  
    // Paw print parallax
    if (pawPrint) {
      gsap.to(pawPrint, {
        y: -30,
        ease: "none",
        scrollTrigger: {
          trigger: featuredSection,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    }
  }

  // === SECTION 2: Intro Section ===
  const introSection = document.querySelector('.s-intro');

  if (introSection) {
    const title = introSection.querySelector(".s-intro__title");
    const introImage = introSection.querySelector('.s-intro__main-image');
    const quoteBlock = introSection.querySelector('.s-intro__quote');
    const quoteTexts = introSection.querySelectorAll('.s-intro__quote-top-text, .s-intro__quote-bottom-text');
    const benefitsBlock = introSection.querySelector('.s-intro__benefits');
    const benefits = introSection.querySelectorAll('.s-intro__benefit');
    const button = introSection.querySelector('.s-intro__benefits-link');

    // Section fade-out as you scroll past
    gsap.fromTo(
      introSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: introSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: introSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Image: slide in from left
    if (introImage) {
      gsap.fromTo(
        introImage,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: introImage,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Quote block: slide in from right
    if (quoteBlock) {
      gsap.fromTo(
        quoteBlock,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: quoteBlock,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Quote texts: scale and fade in
    if (quoteTexts.length) {
      quoteTexts.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, scale: 0.95 },
          {
            opacity: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 60%",
              scrub: true,
            },
          }
        );
      });
    }
  
    // Benefits block: fade in and slide from right
    if (benefitsBlock) {
      gsap.fromTo(
        benefitsBlock,
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: benefitsBlock,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Individual benefit items: staggered in with scrub
    if (benefits.length) {
      benefits.forEach((benefit, i) => {
        gsap.fromTo(
          benefit,
          { x: 20, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            scrollTrigger: {
              trigger: benefit,
              start: `top 90%+=${i * 20}`,
              end: `top 70%+=${i * 20}`,
              scrub: true,
            },
          }
        );
      });
    }
  
    // Animate button pop-in
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 3: Benefits Section ===
  const benefitsSection = document.querySelector('.s-benefits');
  if (benefitsSection) {
    const title = benefitsSection.querySelector(".s-benefits__title");
    const description = benefitsSection.querySelector(".s-benefits__description");
    const benefitItems = benefitsSection.querySelectorAll('.s-benefits__item');
    const dogImage = benefitsSection.querySelector('.s-benefits__img--desktop');
    const yellowDecorDog = benefitsSection.querySelector('.s-benefits__decor');

    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: benefitsSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate description
    if (description) {
      gsap.fromTo(description,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Section fade-out as you scroll past
    gsap.fromTo(
      benefitsSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: benefitsSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Benefit items: fade in from bottom staggered
    if (benefitItems.length) {
      benefitItems.forEach((item, i) => {
        gsap.fromTo(
          item,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: "top 90%+=10",
              end: "top 70%+=10",
              scrub: true
            }
          }
        );
      });
    }
  
    // Dog photo: slide in from right with slight zoom effect
    if (dogImage) {
      gsap.fromTo(
        dogImage,
        { x: 30, opacity: 0 },
        {
          x: 0,
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: dogImage,
            start: "top 80%",
            end: "top 60%",
            scrub: true
          }
        }
      );
    }
  
    // Yellow cartoon dog: bouncy pop-in
    if (yellowDecorDog) {
      gsap.fromTo(
        yellowDecorDog,
        { scale: 0.8, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.6,
          ease: "elastic.out(1, 0.4)",
          scrollTrigger: {
            trigger: yellowDecorDog,
            start: "top 70%",
            end: "top 60%",
            scrub: true
          }
        }
      );
    }
  }

  // === SECTION 4: Featured Collections ===
  const featuredSections = document.querySelector('.s-featured-collections');
  if (featuredSections) {
    const collectionItems = featuredSections.querySelectorAll(".s-featured-collections__item");

    // Section fade-out as you scroll past
    gsap.fromTo(
      featuredSections,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featuredSections,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    collectionItems.forEach((item, i) => {
      gsap.fromTo(
        item,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: item,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          }
        }
      );
    });
  }

  // === SECTION 5: Reviews Section ===
  const reviewSection = document.querySelector('.s-reviews');
  const reviewsSections = document.querySelectorAll('.s-reviews');
  
  // Animate title and description (from the first section)
  if (reviewSection) {
    const title = reviewSection.querySelector(".s-reviews__title");
    const description = reviewSection.querySelector(".s-reviews__description");
  
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    if (description) {
      gsap.fromTo(description,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }
  
  // Animate each review section individually
  reviewsSections.forEach((section) => {
    const reviewItems = section.querySelectorAll('.s-reviews__item');
    const pinkDecorDog = section.querySelector('.s-reviews__img');
    const btnPrev = section.querySelector('.js-reviews__btn--prev .s-reviews__btn-img');
    const btnNext = section.querySelector('.js-reviews__btn--next .s-reviews__btn-img');
    const testimonialTexts = section.querySelectorAll('.s-reviews__testimonial-text');
    const testimonialNames = section.querySelectorAll('.s-reviews__testimonial-name');
    const ratingStars = section.querySelectorAll('.s-reviews__testimonial-star');
  
    // Fade out section on scroll past
    gsap.fromTo(section,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Animate each review item
    reviewItems.forEach((item) => {
      gsap.fromTo(item, { y: 30 }, {
        y: 0,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: item,
          start: "top 90%",
          end: "top 70%",
          scrub: true
        }
      });
    });
  
    // Animate dog image
    if (pinkDecorDog) {
      gsap.fromTo(pinkDecorDog, { x: 60, scale: 0.95, opacity: 0 }, {
        x: 0,
        scale: 1,
        opacity: 1,
        duration: 0.8,
        ease: "elastic.out(1, 0.4)",
        scrollTrigger: {
          trigger: pinkDecorDog,
          start: "top 80%",
          end: "top 60%",
          scrub: true
        }
      });
    }
  
    // Animate arrows
    if (btnPrev && btnNext) {
      gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          end: "top 60%",
          toggleActions: "play none none reset"
        },
        delay: 1
      })
      .to(btnPrev, { scale: 1.4, duration: 0.2, ease: "power1.inOut" })
      .to(btnPrev, { scale: 1, duration: 0.2, ease: "power1.inOut" })
      .to(btnNext, { scale: 1.4, duration: 0.2, ease: "power1.inOut" })
      .to(btnNext, { scale: 1, duration: 0.2, ease: "power1.inOut" });
    }
  
    // Animate testimonial texts
    testimonialTexts.forEach((text) => {
      gsap.fromTo(text,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "bounce.out",
          scrollTrigger: {
            trigger: text,
            start: "top 80%",
            end: "top 20%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    // Animate testimonial names
    testimonialNames.forEach((name) => {
      gsap.fromTo(name,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
          delay: 0.4,
          scrollTrigger: {
            trigger: name,
            start: "top 80%",
            end: "top 20%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    if (ratingStars.length) {
      gsap.fromTo(
        ratingStars,
        { opacity: 0, scale: 0.5, rotate: -10 },
        {
          opacity: 1,
          scale: 1,
          rotate: 0,
          duration: 0.3,
          stagger: 0.07,
          ease: "back.out(1.7)",
          delay: 1,
          scrollTrigger: {
            trigger: ratingStars,
            start: "top 80%",
            end: "top 20%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  });

  // === SECTION 6: Brand Ambassador Animations ===
  const ambassadorSection = document.querySelector(".s-brand-ambassador");
  if (ambassadorSection) {
    const title = ambassadorSection.querySelector(".s-brand-ambassador__title");
    const description = ambassadorSection.querySelector(".s-brand-ambassador__description");
    const dogImages = ambassadorSection.querySelectorAll(".s-brand-ambassador__img");
    const badge = ambassadorSection.querySelector(".s-brand-ambassador__review-rating");
    const speechBubble = ambassadorSection.querySelector(".s-brand-ambassador__review-description");
    const button = ambassadorSection.querySelector(".s-brand-ambassador__review-link");

    // Section fade-out as you scroll past
    gsap.fromTo(
      ambassadorSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ambassadorSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ambassadorSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate description
    if (description) {
      gsap.fromTo(description,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate dog images
    dogImages.forEach((img) => {
      gsap.fromTo(img,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
  
      // Idle pulse loop (independent of scroll)
      gsap.to(img, {
        scale: 1.03,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: 1.5
      });
    });
  
    // Badge "stamp" effect
    if (badge) {
      gsap.fromTo(badge,
        { scale: 0.8, opacity: 0, rotate: -10 },
        {
          scale: 1,
          opacity: 1,
          rotate: 0,
          duration: 0.5,
          ease: "back.out(2)",
          scrollTrigger: {
            trigger: badge,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Speech bubble pop-in
    if (speechBubble) {
      gsap.fromTo(speechBubble,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: speechBubble,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Animate button pop-in
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 7: Featured Articles Animations ===
  const articlesSection = document.querySelector(".s-featured-articles");
  if (articlesSection) {
    const title = articlesSection.querySelector(".s-featured-articles__title");
    const description = articlesSection.querySelector(".s-featured-articles__description");
    const button = articlesSection.querySelector(".s-featured-articles__link");
    const articles = articlesSection.querySelectorAll(".s-featured-articles__item");
    const tags = articlesSection.querySelectorAll(".c-article-card__tag");
    const images = articlesSection.querySelectorAll(".c-article-card__img-wrapper");

    // Section fade-out as you scroll past
    gsap.fromTo(
      articlesSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: articlesSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );
  
    // Headline fade from top
    if (title) {
      gsap.fromTo(title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Description fade from top
    if (description) {
      gsap.fromTo(description,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Articles fade in stagger
    if (articles.length > 0) {
      gsap.fromTo(articles,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.15,
          scrollTrigger: {
            trigger: articlesSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Tags scale-in from left
    tags.forEach((tag) => {
      gsap.fromTo(tag,
        { x: -10, scale: 0.95, opacity: 0 },
        {
          x: 0,
          scale: 1,
          opacity: 1,
          duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: tag,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  
    // Image wrappers zoom/slide on load
    images.forEach((img) => {
      gsap.fromTo(img,
        { scale: 0.96, opacity: 0, y: 10 },
        {
          scale: 1,
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  }

  // === SECTION 8: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 9: Subscription Section Animation ===
  const subscriptionSection = document.querySelector('.s-subscription');
  if (subscriptionSection) {
    const title = subscriptionSection.querySelector('.s-subscription__title');
    const description = subscriptionSection.querySelector('.s-subscription__description');
    const form = subscriptionSection.querySelector('.s-subscription__form');
    const imageWrapper = subscriptionSection.querySelector('.s-subscription__image-wrapper');
    const subscribeButton = subscriptionSection.querySelector('.s-subscription__button');
  
    // Fade up & stagger for text + form (repeatable)
    gsap.from([title, description, form], {
      y: 20,
      opacity: 0,
      stagger: 0.2,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: subscriptionSection,
        start: 'top 80%',
        end: 'bottom 0%',
        toggleActions: 'play reverse play reverse',
      },
    });
  
    // Cat illustration animation (repeatable)
    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { x: 40, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'elastic.out(1, 0.4)',
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }

    // Animate button pop-in (Subscribe)
    if (subscribeButton) {
      gsap.fromTo(
        subscribeButton,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: subscribeButton,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 10: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // === SECTION 11: Video Section Animation ===
  const videoSection = document.querySelector('.video-section');

  if (videoSection) {
    const videoCards = videoSection.querySelectorAll('.video-card');
    const videos = videoSection.querySelectorAll('.video-card video');
    const buttons = videoSection.querySelectorAll('.shop-btn');

    gsap.fromTo(
      videoSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: videoSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (videoCards.length) {
      gsap.fromTo(
        videoCards,
        { y: 50, opacity: 0, scale: 0.96 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: videoSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    videos.forEach((video) => {
      gsap.fromTo(
        video,
        { scale: 0.96 },
        {
          scale: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: video,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    buttons.forEach((button) => {
      gsap.fromTo(
        button,
        { y: 12, opacity: 0, scale: 0.95 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          delay: 0.35,
          duration: 0.45,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 90%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  }

  // === SECTION 12: Video Strip Animation ===
  const videoStrip = document.querySelector('.video-strip');

  if (videoStrip) {
    const videoItems = videoStrip.querySelectorAll('.video-item');
    const videos = videoStrip.querySelectorAll('.video-item video');
    const buttons = videoStrip.querySelectorAll('.insta-btn');

    gsap.fromTo(
      videoStrip,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: videoStrip,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (videoItems.length) {
      gsap.fromTo(
        videoItems,
        { y: 50, opacity: 0, scale: 0.96 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: videoStrip,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    videos.forEach((video) => {
      gsap.fromTo(
        video,
        { scale: 0.96 },
        {
          scale: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: video,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    buttons.forEach((button) => {
      gsap.fromTo(
        button,
        { y: 12, opacity: 0, scale: 0.95 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          delay: 0.35,
          duration: 0.45,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 90%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  }

  // === SECTION 13: Limited Edition Featured Products Animation ===
  const limitedProductsSection = document.querySelector('.featured-products');

  if (limitedProductsSection) {
    const title = limitedProductsSection.querySelector('.fp-header h2');
    const description = limitedProductsSection.querySelector('.fp-header p');
    const cards = limitedProductsSection.querySelectorAll('.fp-card');
    const images = limitedProductsSection.querySelectorAll('.fp-card img');
    const buttons = limitedProductsSection.querySelectorAll('.fp-button');

    gsap.fromTo(
      limitedProductsSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: limitedProductsSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(
        title,
        { y: -24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: limitedProductsSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (description) {
      gsap.fromTo(
        description,
        { y: 16, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: description,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (cards.length) {
      gsap.fromTo(
        cards,
        { y: 50, opacity: 0, scale: 0.96 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: limitedProductsSection,
            start: "top 78%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    images.forEach((image) => {
      gsap.fromTo(
        image,
        { scale: 0.96 },
        {
          scale: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: image,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });

    buttons.forEach((button) => {
      gsap.fromTo(
        button,
        { y: 12, opacity: 0, scale: 0.95 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          delay: 0.35,
          duration: 0.45,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 90%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    });
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
